import React, { useEffect, useState } from "react";
import { Box, Circle, Flex, FormControl, FormLabel, Heading, Input } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import '@mdxeditor/editor/style.css';
import './TextContentElement.css';
import { useFocus } from "./useFocus";
import { PimcoreLink } from "./PimcoreLink";
import { BlockTypeSelect, BoldItalicUnderlineToggles, headingsPlugin, MDXEditor, toolbarPlugin, UndoRedo } from "@mdxeditor/editor";
import { PimcoreImage } from "./PimcoreImage";
import ChakraUIRenderer from "chakra-ui-markdown-renderer";
import Markdown from "react-markdown";
import { PimcoreImageDisplay } from "../components/PimcoreImageDisplay";
import { PimcoreLinkButton } from "../components/PimcoreLinkButton";
import { motion } from "framer-motion";
const defaults = {
    assetId: null,
    content: "Lorem ipsum dolor sit amet",
    link: {
        path: "",
        parameters: "",
        anchor: "",
        accesskey: "",
        rel: "",
        tabindex: "",
        target: "",
        class: "",
        attributes: ""
    },
    title: "Lorem Ipsum"
};
function isBox(element) {
    return element.type === "box";
}
export const BoxContentElement = (props) => {
    var _a, _b, _c;
    const [ref, setRef] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    useEffect(() => {
        if (!isBox(props.contentElement) || props.contentElement.data == null) {
            const element = Object.assign(Object.assign({}, props.contentElement), { type: "box", data: defaults });
            props.onChange(element);
        }
    }, [props.contentElement]);
    if (!isBox(props.contentElement) || props.contentElement.data == null) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Flex, Object.assign({ ref: setRef }, containerProps),
        ref && isActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, label: "Box", attachTo: ref },
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Title"),
                    React.createElement(Input, { value: props.contentElement.data.title, onChange: e => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { title: e.target.value }) })) })),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Content"),
                    React.createElement(MDXEditor, { markdown: props.contentElement.data.content, plugins: [
                            headingsPlugin(),
                            toolbarPlugin({
                                toolbarContents: () => (React.createElement(React.Fragment, null,
                                    React.createElement(BlockTypeSelect, null),
                                    React.createElement(UndoRedo, null),
                                    React.createElement(BoldItalicUnderlineToggles, null)))
                            })
                        ], onChange: content => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { content }) })) })),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Icon"),
                    React.createElement(PimcoreImage, { data: props.contentElement.data.assetId ? {
                            id: props.contentElement.data.assetId,
                            alt: ""
                        } : null, onChange: data => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { assetId: data.id }) })) })),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "CTA"),
                    React.createElement(PimcoreLink, { link: props.contentElement.data.link, onChange: data => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { link: data }) })) }))),
        React.createElement(Flex, { flexDirection: "column", alignItems: "center", gap: 12, flex: 1, position: "relative", borderRadius: "3xl", overflow: "hidden", p: 12, textAlign: "center" },
            React.createElement(motion.div, { style: { position: "absolute", top: "-30px", zIndex: -1 }, animate: { left: ["-20px", "-5px"] }, transition: { repeat: Infinity, duration: 2, repeatType: "reverse" } },
                React.createElement(Circle, { size: "100px", bg: "brand.300", filter: "auto", blur: "50px" })),
            React.createElement(motion.div, { style: { position: "absolute", zIndex: -1 }, animate: { right: ["50%", "15%"], top: ["-200px", "-100px"], opacity: [1, 0.8] }, transition: { repeat: Infinity, duration: 5, repeatType: "reverse" } },
                React.createElement(Circle, { size: "300px", bg: "brand.600", filter: "auto", blur: "100px" })),
            React.createElement(Circle, { size: "200px", bg: "brand.500", filter: "auto", blur: "80px", position: "absolute", right: "5px", top: "-50px", zIndex: -1 }),
            React.createElement(Flex, { alignItems: "center", flexDirection: "column", gap: 6 },
                props.contentElement.data.assetId &&
                    React.createElement(PimcoreImageDisplay, { assetId: props.contentElement.data.assetId, width: "5rem", height: "4.5rem", objectFit: "contain" }),
                React.createElement(Heading, { as: "h3", fontWeight: "black", fontSize: ["2rem", "2.25rem"], color: "brand.900" }, props.contentElement.data.title)),
            React.createElement(Box, { whiteSpace: "pre-wrap" },
                React.createElement(Markdown, { components: ChakraUIRenderer() }, props.contentElement.data.content)),
            ((_a = props.contentElement.data.link.text) !== null && _a !== void 0 ? _a : false) && ((_b = props.contentElement.data.link.path) !== null && _b !== void 0 ? _b : false) &&
                React.createElement(PimcoreLinkButton, { variant: "outline", colorScheme: "brand", size: "xl", link: props.contentElement.data.link }, (_c = props.contentElement.data.link.text) !== null && _c !== void 0 ? _c : ""))));
};
